import { Label } from '../Label';

declare let THREE: any;

export class Text extends Label {

  private static axisDirection = new THREE.Vector3(1, 0, 0);
  private text: string;

  private static calculateAngle(direction): number {
    const angle = direction.angleTo(Text.axisDirection);
    return THREE.Math.radToDeg(angle);
  }

  private updatePosition(direction) {
    const axisOffset = Text.axisDirection.clone().multiplyScalar(this.scale.x / 2);
    const offsetTowardsLine = direction.clone().multiplyScalar(this.scale.z / 2);
    const offset = axisOffset.add(offsetTowardsLine);
    this.position.copy(offset);
  }

  update(startPoint, endPoint) {
    const direction = endPoint.clone().sub(startPoint).normalize();
    this.text = Text.calculateAngle(direction).toFixed(2);
    super.updateText(this.text);
    this.updatePosition(direction);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/proTools/object3D/Angle/Text.ts